const VendorData = [

    {
        id: 1,
        vendorName: "Couture Cakes",
        vendorPhone: "5553425327",
        vendorBudget: "$200"
    },

    {
        id: 2,
        vendorName: "Keepsake Memories Photography",
        vendorPhone: "5554539718",
        vendorBudget: "$600"
    }
    
]

export default VendorData